<template>
  <div class="material-option__finish-select">
    <p class="is-size-5 has-text-grey">
      {{ $t("checkout.configure.inputLabels.finishOptions") }}
    </p>
    <div class="py-3 block has-background-light">
      <b-radio
        v-for="surfaceFinish in availableSurfaceFinishes"
        :key="`surface-finish-option__${surfaceFinish._id}`"
        class="has-background-light pr-3 has-text-black"
        :native-value="surfaceFinish._id"
        v-model="selectedFinishId"
        >{{ surfaceFinish.properties.name }}
      </b-radio>
    </div>

    <div class="material-option__color-select">
      <p class="is-size-5 has-text-grey p-2" v-if="selectedFinishId">
        <template v-if="isLoading">
          <b-skeleton width="300"></b-skeleton>
        </template>
        <template v-else> {{$t('printMode.chooseColor')}} </template>
      </p>
      <b-field
        class="has-background-light mx-2"
        v-for="color in availableColors"
        expanded
        :key="`color-${color.surfaceFinishId}-option__${color._id}`"
      >
        <b-radio-button
          :native-value="color._id"
          :type="
            color.pricing && color.pricing.printable ? 'is-white' : 'is-warning'
          "
          title="Nicht druckbar"
          v-model="selectedColorId"
          focussed
          expanded
        >
          <div
            class="
              is-inline-flex is-justify-content-flex-start is-align-items-center
            "
            style="width: 100%"
          >
            <span v-if="isLoading">
              <b-skeleton width="96" height="8"></b-skeleton>
            </span>
            <span
              v-else
              class="item--color__preview"
              :style="{ background: color.hex }"
            >
            </span>
            <div class="item--color__meta is-inline-flex is-align-items-center">
              <span class="item--color__label ml-3">
                <template v-if="isLoading">
                  <b-skeleton width="80"></b-skeleton>
                </template>
                <template v-else>{{ color.name }} </template>
              </span>
              <template v-if="!isLoading">
                <PrintModePrice
                  :print-mode="printMode"
                  :current-color="color"
                ></PrintModePrice>
              </template>
            </div>
            <b-icon
              :icon="selectedColorId === color._id ? 'check' : ''"
            ></b-icon>
          </div>
        </b-radio-button>
      </b-field>
    </div>
  </div>
</template>

<script>
import PrintModePrice from "./PrintModePrice";
import { mapGetters } from "vuex";
import { eventBus } from "../../../events/event-bus";

export default {
  name: "PrintModeChooseFinishes",
  components: { PrintModePrice },
  data() {
    return {
      isOpen: false,
      isLoading: false,
      selectedColorIndex: 0,
      rainbowGradient:
        "linear-gradient(135deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 40%, rgba(252,176,69,1) 56%, rgba(253,231,42,1) 76%, rgba(114,253,50,1) 100%)",
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    ...mapGetters(["currentCartItem", "printModes"]),
    printMode() {
      return this.$store.getters.printModeById(
        this.currentCartItem.printModeId
      );
    },
    availableSurfaceFinishes() {
      return this.printMode.surfaceFinishes;
    },
    selectedColor: {
      get() {
        return this.currentCartItem.color;
      },
      set(value) {
        this.$store.dispatch("updateCurrentCartItem", {
          color: value,
        });
      },
    },
    selectedColorId: {
      get() {
        return this.selectedColor._id;
      },
      set(id) {
        const color = this.printMode.surfaceFinishes
          .find((finish) => finish.id === this.selectedFinishId)
          .colors.find((color) => color._id === id);
        if (color) {
          this.selectedColor = color;
          this.$emit("change", color);
        }
      },
    },
    selectedFinishId: {
      get() {
        return this.currentCartItem.surfaceFinishId || null;
      },
      set(value) {
        this.$store.dispatch("updateCurrentCartItem", {
          surfaceFinishId: value,
        });
        this.selectedColorId = this.printMode.surfaceFinishes.find(
          (finish) => finish.id === value
        ).colors[0]._id;
      },
    },
    availableColors() {
      let surfaceFinish = this.printMode.surfaceFinishes.find(
        (finish) => finish.id === this.selectedFinishId
      );

      return surfaceFinish.colors.map((color) => {
        return {
          ...color,
          surfaceFinishId: surfaceFinish.id,
        };
      });
    },
  },
  methods: {
    isFinishAvailable(id) {
      return (
        this.printMode.colors.filter((color) => {
          return color.surfaceFinishes.includes(id);
        }).length > 0
      );
    },
    async calculatePricing() {
      this.isLoading = true;
      await this.$store.dispatch("fetchPrintModePrices", this.printMode.id);
      this.isLoading = false;
    },
  },
  mounted() {
    eventBus.$on("cartItemPricingInvalid", this.calculatePricing);
  },
  beforeDestroy() {
    eventBus.$off("cartItemPricingInvalid", this.calculatePricing);
  },
};
</script>

<style scoped></style>
